package de.ohhhmhhh.frontend.admin.ui.screens.text.edit

import androidx.compose.runtime.Composable
import de.ohhhmhhh.frontend.admin.helper.Constants
import de.ohhhmhhh.frontend.admin.navigation.Navigator
import de.ohhhmhhh.frontend.admin.navigation.Screen

@Composable
fun TextEditPage(
    viewModel: TextEditViewModel,
    state: TextEditState,
    navigator: Navigator
) {
    TextEditPageContent(
        state = state,
        setTitle = viewModel::setTitle,
        setContent = viewModel::setContent,
        setRevision = viewModel::setRevision,
        save = viewModel::save,
        open = {
            state.version?.let {
                "${Constants.FRONTEND_URL}/texts/${state.id}?version=$it"
            }?.also {
                navigator.navigate(Screen.External(it), true)
            }
        },
        back = navigator::backwards
    )
}